import React from "react";

import { AddCircle } from "@mui/icons-material";
import { Card, CardActionArea, CardContent, Typography } from "@mui/material";

interface AudienceCardProps {
  onClick(): void;
  title?: string;
}

const AddAudienceCard: React.FC<AudienceCardProps> = (
  {
    onClick,
    title = 'Add Segment'
  }) => {
  return (
    <Card
      variant="outlined"
      sx={{
        background: "transparent",
        width: "140px",
      }}
    >
      <CardActionArea onClick={onClick}>
        <CardContent
          sx={{
            height: "80px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <AddCircle color="inherit" />
          <Typography
            variant="body2"
            textAlign="center"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: "2",
              WebkitBoxOrient: "vertical",
            }}
          >
            {title}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default AddAudienceCard;
